import { Component } from '@angular/core';

@Component({
  selector: 'kpi-grid',
  templateUrl: './kpi-grid.component.html',
  styleUrls: ['./kpi-grid.component.scss'],
})
export class KpiGridComponent {}
